import axios from 'axios'
const baseUrll = "http://165.232.80.248:7000"
const baseUrll2 = "http://165.232.80.248:7000/"
export const baseUrl = baseUrll2
export const getCall = (endPoint, body = {}) => {
    const config = {
        headers: {
            'content-type': 'application/json',
        },
        baseURL: baseUrll,
    };
    return axios.post(endPoint, body, config)
}
